<template>
  <div class="module-wrap">
    <div class="sub-title">走访信息</div>
    <div class="common-border">
      <el-row :gutter="20">
        <!-- 走访时间 -->
        <el-col :span="6">
          <el-form-item
            label="走访时间"
            prop="goodsYardVisitReq.visitDate"
            required
          >
            <el-date-picker
              v-model="formData.visitDate"
              type="date"
              value-format="yyyy-MM-dd HH:mm:ss"
              placeholder="选择日期"
              :default-value="new Date()"
              style="width: 95%"
            />
          </el-form-item>
        </el-col>

        <!-- 货场库存 -->
        <el-col :span="6">
          <el-form-item
            label="货场库存"
            prop="goodsYardVisitReq.goodsYardInventory"
            required
          >
            <el-input
              v-model="formData.goodsYardInventory"
              maxlength="10"
              type="number"
            >
              <template slot="append">套</template>
            </el-input>
          </el-form-item>
        </el-col>

        <!-- 回收价格信息 -->
        <el-col :span="6">
          <el-form-item
            label="回收价(单片)"
            prop="goodsYardVisitReq.singleAirconditionRecyclePrice"
            required
          >
            <el-input
              v-model="formData.singleAirconditionRecyclePrice"
              maxlength="10"
              type="number"
              step="0.01"
            >
              <template slot="append">元/KG</template>
            </el-input>
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item
            label="回收价(双片)"
            prop="goodsYardVisitReq.doubleAirconditionRecyclePrice"
            required
          >
            <el-input
              v-model="formData.doubleAirconditionRecyclePrice"
              maxlength="10"
              type="number"
              step="0.01"
            >
              <template slot="append">元/KG</template>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <!-- 出货价格信息 -->
        <el-col :span="6">
          <el-form-item
            label="出货价(单片)"
            prop="goodsYardVisitReq.singleAirconditionSellPrice"
            required
          >
            <el-input
              v-model="formData.singleAirconditionSellPrice"
              maxlength="10"
              type="number"
              step="0.01"
            >
              <template slot="append">元/KG</template>
            </el-input>
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item
            label="出货价(双片)"
            prop="goodsYardVisitReq.doubleAirconditionSellPrice"
            required
          >
            <el-input
              v-model="formData.doubleAirconditionSellPrice"
              maxlength="10"
              type="number"
              step="0.01"
            >
              <template slot="append">元/KG</template>
            </el-input>
          </el-form-item>
        </el-col>

        <!-- 最近供货时间 -->
        <el-col :span="6">
          <el-form-item
            label="最近供货时间"
            prop="goodsYardVisitReq.latestSupplyDate"
            required
          >
            <el-date-picker
              v-model="formData.latestSupplyDate"
              type="date"
              value-format="yyyy-MM-dd HH:mm:ss"
              placeholder="选择日期"
            />
          </el-form-item>
        </el-col>
      </el-row>

      <!-- 文本区域信息 -->
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item
            label="近期出货计划"
            prop="goodsYardVisitReq.latestShipmentPlan"
            required
          >
            <el-input
              v-model="formData.latestShipmentPlan"
              type="textarea"
              maxlength="150"
              show-word-limit
            />
          </el-form-item>
        </el-col>

        <el-col :span="24">
          <el-form-item
            label="合作模式"
            prop="goodsYardVisitReq.partnerMode"
            required
          >
            <el-input
              v-model="formData.partnerMode"
              type="textarea"
              maxlength="150"
              show-word-limit
            />
          </el-form-item>
        </el-col>

        <el-col :span="24">
          <el-form-item
            label="货源流向"
            prop="goodsYardVisitReq.sourceFlow"
            required
          >
            <el-input
              v-model="formData.sourceFlow"
              type="textarea"
              maxlength="150"
              show-word-limit
            />
          </el-form-item>
        </el-col>

        <el-col :span="24">
          <el-form-item
            label="合作供应商"
            prop="goodsYardVisitReq.cooperativeSuppliers"
            required
          >
            <el-input
              v-model="formData.cooperativeSuppliers"
              type="textarea"
              maxlength="150"
              show-word-limit
            />
          </el-form-item>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  name: "VisitInfoSection",

  props: {
    formData: {
      type: Object,
      required: true,
    },
  },
};
</script>





// WEBPACK FOOTER //
// src/views/dataBoard/components/VisitInfoSection.vue